import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import LegalPage from './components/layout/LegalPage';
import { LEGAL_DOCS } from './lib/legal';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route
          path={LEGAL_DOCS.privacy.path}
          element={<LegalPage doc="privacy" />}
        />
        <Route
          path={LEGAL_DOCS.terms.path}
          element={<LegalPage doc="terms" />}
        />
        {/* Everything else is the single-page site */}
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
